export const maskCPF = ["###.###.###-##"];
export const maskCEP = ["#####-###"];
export const maskDate = ["##/##/####"];
export const maskCNPJ = ["##.###.###/####-##"];
export const maskCPFCNPJ = ["###.###.###-##", "##.###.###/####-##"];
export const maskNumberProcess = ["#######-##.####.#.##.####"];
export const maskPhone = ["(##) ###-####", "(##) ####-####", "(##) #####-####"];
export const maskIntervalDate = ["##/##/#### - ##/##/####"];
export const maskCNAE = ["####-#/##"];
